import React, { Component } from "react";
import { Button, ButtonGroup } from "reactstrap";
import { connect } from "react-redux";
import ReactTable from "react-table";
import "react-table/react-table.css";
import * as actions from "../../actions";
import { hotelsDataColumns } from "./Components/dataColumns";
import { Spinner } from "react-activity";
import "react-activity/dist/react-activity.css";
import NewHotelModal from "./Components/NewHotelModal";
import DeleteHotelModal from "./Components/DeleteHotelModal";
import "./Hotels.css";

class Hotels extends Component {
  componentDidMount() {}

  updateHotelProps = payload => {
    this.props.updateHotelProps(payload);
  };
  mergeHotelProps = payload => {
    this.props.mergeHotelProps(payload);
  };
  deleteHotelProps = payload => {
    this.props.deleteHotelProps(payload);
  };
  deleteHotel = hotelOrIndex => {
    const hotelRows = this.props.hotelsReducer.hotels && this.props.hotelsReducer.hotels.data
      ? this.props.hotelsReducer.hotels.data
      : [];
    const index =
      typeof hotelOrIndex === "number"
        ? hotelOrIndex
        : hotelRows.findIndex(
            hotel =>
              hotel &&
              (hotel === hotelOrIndex ||
                String(hotel.id) === String(hotelOrIndex.id))
          );
    this.updateHotelProps([
      { prop: "deleteHotelIndex", value: index },
      { prop: "isDeleteHotelModalOpen", value: true }
    ]);
  };
  confirmDeleteHotel = () => {
    const { deleteHotelIndex, hotels } = this.props.hotelsReducer;
    const hotelRows = hotels && hotels.data ? hotels.data : [];
    const hotel = deleteHotelIndex !== null ? hotelRows[deleteHotelIndex] : null;

    if (hotel) {
      this.props.deleteHotel(hotel, deleteHotelIndex);
    }

    this.updateHotelProps([
      { prop: "deleteHotelIndex", value: null },
      { prop: "isDeleteHotelModalOpen", value: false }
    ]);
  };
  createHotels = hotels => {
    this.props.createHotels(hotels);
  };
  paginate = (tableState, tableInstance) => {
    let param = {};
    if (tableState.sorted.length !== 0) {
      param.sort_column = tableState.sorted[0].id;
      param.sort_type = tableState.sorted[0].desc ? "desc" : "asc";
    }
    if (tableState.filtered.length !== 0) {
      param.filters = [];
      for (let i = 0; i < tableState.filtered.length; i++) {
        // tableState.filtered[i].id
        param.filters.push({ filter_column: tableState.filtered[i].id, filter_value: tableState.filtered[i].value });
      }
    }
    param.page_size = tableState.pageSize;
    this.props.getHotels("hotels", tableState.page + 1, param);
  };

  render() {
    const {
      hotels,
      isHotelsTableEditable,
      isHotelSaving,
      isNewHotelModalOpen,
      newHotels,
      isHotelCreating,
      isHotelLoading,
      isDeleteHotelModalOpen,
      deleteHotelIndex
    } = this.props.hotelsReducer;
    const hotelRows = hotels && hotels.data ? hotels.data : [];
    const { last_page } = hotels;
    const deleteHotelRecord =
      deleteHotelIndex !== null ? hotelRows[deleteHotelIndex] : null;
    const editableRows = hotelRows.filter(hotel => hotel && hotel.edited).length;
    return (
      <div className="hotels-page">
        <NewHotelModal
          isOpen={isNewHotelModalOpen}
          updateHotelProps={this.updateHotelProps}
          mergeHotelProps={this.mergeHotelProps}
          deleteHotelProps={this.deleteHotelProps}
          createHotels={this.createHotels}
          newHotels={newHotels}
          isHotelCreating={isHotelCreating}
        />
        <DeleteHotelModal
          isOpen={isDeleteHotelModalOpen}
          hotel={deleteHotelRecord}
          isDeleting={!!(deleteHotelRecord && deleteHotelRecord.isDeleting)}
          onCancel={() => {
            this.updateHotelProps([
              { prop: "deleteHotelIndex", value: null },
              { prop: "isDeleteHotelModalOpen", value: false }
            ]);
          }}
          onConfirm={this.confirmDeleteHotel}
        />

        <div className="hotels-page__hero">
          <div>
            <div className="hotels-page__eyebrow">Inventory</div>
            <h1 className="hotels-page__title">Hotels</h1>
            <p className="hotels-page__copy">
              Manage the hotel directory used by reservations and room assignments from one
              cleaner workspace.
            </p>
          </div>

          <div className="hotels-page__stats">
            <div className="hotels-stat">
              <span className="hotels-stat__value">{hotelRows.length}</span>
              <span className="hotels-stat__label">Visible hotels</span>
            </div>
            <div className="hotels-stat">
              <span className="hotels-stat__value">{editableRows}</span>
              <span className="hotels-stat__label">Pending edits</span>
            </div>
            <div className="hotels-stat">
              <span className="hotels-stat__value">{isHotelLoading ? "Syncing" : "Ready"}</span>
              <span className="hotels-stat__label">Data state</span>
            </div>
          </div>
        </div>

        <div className="hotels-toolbar">
          <div className="hotels-toolbar__group">
            <ButtonGroup>
              <Button
                color={"faiz3"}
                onClick={() => {
                  this.updateHotelProps([{ prop: "isNewHotelModalOpen", value: true }]);
                }}
              >
                <i className={"fa fa-plus"} /> New Hotel
              </Button>
              <Button
                color={"faiz1"}
                onClick={() => {
                  this.props.getHotels("hotels", 1, {});
                }}
              >
                Refresh
              </Button>
            </ButtonGroup>
          </div>

          <div className="hotels-toolbar__group">
            <ButtonGroup>
              {isHotelsTableEditable ? (
                <Button
                  color={"faiz2"}
                  onClick={() => {
                    this.props.saveHotels(hotels);
                  }}
                  disabled={isHotelSaving}
                >
                  {isHotelSaving ? (
                    <>
                      <Spinner size={10} animating={true} color={"white"} />
                      &nbsp;
                    </>
                  ) : null}
                  <i className={"fa fa-floppy-o"} /> Save
                </Button>
              ) : (
                <Button
                  color={"faiz1"}
                  onClick={() => {
                    this.props.updateHotelProps([{ prop: "isHotelsTableEditable", value: true }]);
                  }}
                  disabled={isHotelSaving}
                >
                  <i className={"fa fa-pencil"} /> Edit
                </Button>
              )}
            </ButtonGroup>
          </div>
        </div>

        <div className="hotels-card">
          <div className="hotels-card__header">
            <div className="hotels-card__eyebrow">Hotel Directory</div>
            <h2 className="hotels-card__title">Active Hotels</h2>
            <p className="hotels-card__copy">
              Search and update hotel records inline, then save the changed rows when you are ready.
            </p>
          </div>

          <div className="hotels-table-shell">
            <ReactTable
              data={hotelRows}
              columns={hotelsDataColumns(this.updateHotelProps, isHotelsTableEditable, this.deleteHotel)}
              className="-highlight -striped hotels-table"
              defaultPageSize={10}
              filterable
              manual
              pages={last_page != null ? last_page : -1}
              onFetchData={this.paginate}
              loading={isHotelLoading}
            />
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ hotelsReducer }) => ({
  hotelsReducer
});

export default connect(
  mapStateToProps,
  actions
)(Hotels);
